
export default {
  name: 'MegasredaRecomendedAuthorBlock',
  props: {
    authorId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      limit: 2,
      materials: null,
      videos: null,
      lectures: null,
      goods: null,
      offers: null,
      events: null,
      vacancys: null,
    }
  },
  async fetch() {
    const { materials, videos, offers, events, vacancys, goods } =
      await this.$axios.$get('author/recomended/aside', {
        params: {
          userId: this.authorId,
          limit: this.limit,
        },
      })

    this.materials = materials
    this.videos = videos
    this.offers = offers
    this.goods = goods
    this.events = events
    this.vacancys = vacancys
  },
  computed: {
    isAuthor() {
      if (this.$auth.loggedIn && this.authorId) {
        return this.$auth?.user?._id === this.authorId
      } else {
        return false
      }
    },
    isEmpty() {
      return (
        !this.materials?.articles?.length &&
        !this.offers?.products?.length &&
        !this.goods?.products?.length &&
        !this.events?.products?.length &&
        !this.vacancys?.products?.length
      )
    },
  },
}
